export default __webpack_public_path__ + "static/media/TarotCardBackground1.89cbbc38.png";